import { render, staticRenderFns } from "./ReviewOverview.vue?vue&type=template&id=45ad7cb6&scoped=true&"
import script from "./ReviewOverview.vue?vue&type=script&lang=ts&"
export * from "./ReviewOverview.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewOverview.vue?vue&type=style&index=0&id=45ad7cb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ad7cb6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ReviewPercentageBar: require('/opt/build/repo/apps/shop/components/ReviewPercentageBar.vue').default})
